import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { datasourceOptions } from "@via/utils/form-validators.tsx";
import { useForm } from "react-hook-form";
import { FileListFromWebRequestBody } from "common";
import FormInputComponent from "@via/components/inputs/form-input-component.tsx";
import { exampleUrlLink } from "@via/pages/data/data-sources/api-data-sources/url/url-data-connector.tsx";
import { ROUTES } from "@via/utils/constants.tsx";
import { useUrlDataConnection } from "@via/hooks/useUrlDataConnection.tsx";

const UrlConnector: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setStarterUrl } = useUrlDataConnection();

  const { control, handleSubmit, setValue } =
    useForm<FileListFromWebRequestBody>({
      mode: "onChange",
      defaultValues: {
        url: "",
      },
    });

  const setExampleUrl = () => {
    setValue("url", exampleUrlLink);
    handleSubmit(handleUrlConnectionFormSubmit)();
  };

  const handleUrlConnectionFormSubmit = (
    payload: FileListFromWebRequestBody
  ) => {
    setStarterUrl(payload.url);
    const datasetId = searchParams.get("datasetId");
    const url = datasetId
      ? `${ROUTES.DATA_SOURCE_PROVIDER_URL}?datasetId=${datasetId}`
      : `${ROUTES.DATA_SOURCE_PROVIDER_URL}`;
    navigate(url);
  };

  const handleCancel = (): void => {
    navigate(ROUTES.DATA);
  };

  return (
    <div>
      <form
        onSubmit={e => {
          e.preventDefault();
          handleSubmit(handleUrlConnectionFormSubmit)(e);
        }}>
        <div className="max-w-[850px] mx-auto space-y-6 pb-5 pt-3">
          <div className="max-w-[850px] space-y-6 pb-5 pt-6">
            <div className="mt-2">
              <FormInputComponent
                name="url"
                label="Web Url"
                placeholder="Web URL"
                showRequiredField={true}
                control={control}
                validations={datasourceOptions.path}
              />
              <div className="flex flex-col gap-2 mt-4 text-sm font-normal text-gray-500">
                <div>
                  Enter the full web address (including “http://” or
                  “https://”). Foundry will use the provided URL to retrieve the
                  list of files from that link.
                </div>

                <div className="flex gap-2">
                  Example link:
                  <button
                    type="button"
                    onClick={() => setExampleUrl()}
                    className="font-bold">
                    {exampleUrlLink}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-shrink-0 justify-end py-4">
            <button
              type="button"
              data-testid="urlConnectorCancelButton"
              onClick={handleCancel}
              className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
              Cancel
            </button>
            <button
              data-testid="urlConnectorSubmitButton"
              type="submit"
              className="ml-4 inline-flex justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
              Connect
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default UrlConnector;
